<template>
  <div>
    <div class="title">
      {{title}}
    </div>
    <div class="title-en">
      {{subTitle}}
    </div>
  </div>
</template>

<script>
export default {
  name:'CustomTitle',
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
  },
  data() {

    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="scss">
.title{
  font-weight: 500;
  font-size: 48px;
  color: #333333;
}
.title-en{
  font-weight: 600;
  font-size: 20px;
  color: #AD867E;
  margin-top: 15px;
}
</style>
